import { render } from "./SegmentModal.vue?vue&type=template&id=5b77c94c"
import script from "./SegmentModal.vue?vue&type=script&lang=js"
export * from "./SegmentModal.vue?vue&type=script&lang=js"

import "./SegmentModal.vue?vue&type=style&index=0&id=5b77c94c&lang=css"

import exportComponent from "/home/nodeapps/uzb/frontendBuild/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__